module.exports = __webpack_public_path__ + "img/Logo-25.a3171693.svg";